<template>
    <section class="container error-message-section" v-if="error">
        <p class="error-message">{{ error }}</p>
    </section>
</template>
<script>

export default {
    name: "ErrorMessage",
    data() {
        return {
            error: null
        }
    },
    created() {
        this.$root.$on('error-occured', (message) => {
            this.error = message;
        })
        this.$root.$on('clear-error', () => {
            this.error = null;
        })
    },
}
</script>
